import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import createExportThunk from "slices/captureDashboard/createExportThunk";
import { selectFilters } from "slices/captureDashboard/selectors";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/capture-dashboard/widgets/pipeline-value-by-customer";
const CSV_FILENAME = "Pipeline Value by Customer.csv";
const PDF_FILENAME = "Pipeline Value by Customer.pdf";

export const fetchPipelineValueByCustomer = createAsyncThunk(
  "pipelineValueByCustomer/fetch",
  async (_, { getState }) => {
    const filters = selectFilters(getState());
    const { periodStart, periodEnd } = resolvePeriod(filters);

    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd },
    });
    return data;
  },
);

export const exportPipelineValueByCustomerCsv = createExportThunk(BASE_URL, "csv", CSV_FILENAME);
export const exportPipelineValueByCustomerPdf = createExportThunk(BASE_URL, "pdf", PDF_FILENAME);
